



































































































































































































































































































































































































































import {
	Component,
	Prop,
	Vue,
	Mixins
} from 'vue-property-decorator';
import BaseMixin from '@/components/mixins/base';
import QueryBuilderMixin from '@/components/mixins/queryBuilderMixin';
import CaptionedField from './captioned-field.vue';
import { DxRequiredRule, DxValidator, DxStringLengthRule } from 'devextreme-vue/validator';
import DxTextBox from 'devextreme-vue/text-box';
import { DxSelectBox } from 'devextreme-vue/select-box';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxList from 'devextreme-vue/list';
import DxButton from 'devextreme-vue/button';
import DxColorBox from 'devextreme-vue/color-box';
import DxCheckBox from 'devextreme-vue/check-box';
import { DxTooltip } from 'devextreme-vue/tooltip';
import ChartCreateQueryFields from './chart-create-query-fields.vue';
import GranularitySelection from './granularity-selection.vue';
import ChartRenderNew from '@/components/charts/ChartRenderNew.vue';
import QueryBuilderGlobal from '@/components/charts/QueryBuilderGlobal.vue';
import { QueryBuilder } from '@cubejs-client/vue';
import { Query, TCubeMeasure } from '@cubejs-client/core';
import FilterBuilder from './filter-builder.vue';
import { apiService, cubejsService, customerService, colorService } from '@/container';
import { CreateChartModel, ChartType } from './types';
import { isEqual, cloneDeep, isNil, isArray, isEmpty } from 'lodash';
import { Portal, PortalTarget } from 'portal-vue';
import { getDefaultChartConfig, IChartConfig } from '@/components/charts/resultSetTransform';
import { tryTranslateCaption } from '@/components/charts/resultSetTransform/chartSteps';
import draggable from 'vuedraggable';
import { DxText } from 'devextreme-vue/linear-gauge';
import dxTextBox from 'devextreme/ui/text_box';
import { Popup } from '@/components';
import { DxScrollView } from 'devextreme-vue/scroll-view';


@Component({
	components: {
		CaptionedField,
		DxTextBox,
		DxSelectBox,
		DxDropDownBox,
		DxList,
		DxButton,
		DxTooltip,
		DxColorBox,
		DxCheckBox,
		draggable,
		QueryBuilder,
		ChartCreateQueryFields,
		GranularitySelection,
		ChartRenderNew,
		QueryBuilderGlobal,
		Portal, PortalTarget,
		FilterBuilder,
		DxRequiredRule, DxValidator, DxStringLengthRule,
		Popup,
		DxScrollView
	}, name: 'ChartCreateMultiple'
})
export default class ChartCreateMultiple extends Mixins(QueryBuilderMixin, BaseMixin) {
	[x: string]: any;

	loading = true;

	readonly maxNameLength: number = 100;
	cubejsApi: any = null;
	isNameValid = true;
	genericFields: string[] = [];
	model: any = {
		name: null,
		chartType: null,
		dimensions: [],
		timeDimensions: []
	}
	groupedByWeek = false;
	preloadedQueries: any[] = [];
	queries: any[] = [{ id: +new Date, queryJson: {} }];
	availableDimensions: any[] = [];
	availableDimensionsPopup: any[] = [];
	availableMeasures: any[] = [];
	availableTimeDimensions: any[] = [];
	producedQuery: any = {};
	addQueryTooltipVisibility = false;
	customer: string | null = null;
	chartConfigs: IChartConfig[] = [{ idQuery: this.queries[0].id, ...getDefaultChartConfig() }];
	isCustomizationpanelOpened = true;
	isQueryVisible: boolean[] = [];
	drillDownDimension: string | null = null;
	isDrillDownPopupVisible = false;

	internalGroupedByWeek = false;
	internalTimeDimensions: string[] = [];
	isDimensionsDropDownBoxOpened = false;
	internalChartType = 'line';
	internalGlobalQuery: any | null = null;
	preloadedQuery: any = {};
	internalChartConfig: IChartConfig[] | null = null;
	internalDrillDownDimension: string | null = null;
	internalGlobalFilter: any = null;

	isDrillDownPopupNew = true;
	drillDownDimensionList: any[] = [];
	get isInDrillDownMode() {
		return !isNil(this.drillDownPreviousQueries) && isArray(this.drillDownPreviousQueries) && this.drillDownPreviousQueries.length > 0;
	}
	drillDownPreviousQueries: any[] = [];

	saveStatusBeforeDrilldown() {
		this.drillDownPreviousQueries.push({
			queries: cloneDeep(this.queries),
			model: cloneDeep(this.model),
			chartConfigs: cloneDeep(this.chartConfigs),
			globalFilter: cloneDeep(this.globalFilter),
			groupedByWeek: cloneDeep(this.groupedByWeek),
			globalQuery: cloneDeep(this.globalQuery),
			drillDownDimension: cloneDeep(this.drillDownDimension)
		});
	}

	chartrenderUpdateKey = 0;
	async reloadQuery(): Promise<void> {
		if (this.isInDrillDownMode) {
			const {
				queries,
				model,
				chartConfigs,
				globalFilter,
				groupedByWeek,
				globalQuery,
				drillDownDimension
			} = this.drillDownPreviousQueries.pop();
			this.model = model;
			this.chartConfigs = chartConfigs;
			this.globalFilter = globalFilter;
			this.groupedByWeek = groupedByWeek;
			this.globalQuery = globalQuery;
			this.drillDownDimension = drillDownDimension;
			this.queries = [];
			if (isNil(queries) || !isArray(queries) || queries.length === 0)
					this.queries.push({ id: +new Date, queryJson: {} });
			else
				queries.forEach((query) => {
					if (!isNil(query.filters) && isArray(query.filters) && query.filters.length > 0) {
						query.filters = _.differenceWith(query.filters, this.globalFilter, _.isEqual);
						if (query.filters.length > 0) {
							query.filters[0].and = _.differenceWith(query.filters[0].and, this.globalFilter, _.isEqual);
						}
					}

					this.queries.push(query);
				});

			this.chartrenderUpdateKey++;
		}

	}


	getValueDropDownBox(item, dimensions, drillDownDimensionList, index) {
		return item.isNew ? dimensions.map(x => x.name) : drillDownDimensionList[index].items;
	}

	getValueList(item, dimensions, drillDownDimensionList, index) {
		return item.isNew ? dimensions : drillDownDimensionList[index].selected;
	}

	availableDimensionsFiltered(availableDimensions) {
		this.availableDimensionsPopup = this.filterAndMapFields(availableDimensions, this.genericFieldsDictionary);
		return this.filterAndMapFields(availableDimensions, this.genericFieldsDictionary);
	}

	onChangeDimensionsDropDownBoxValue({ addedItems, removedItems }:
		{
			addedItems: { name: string }[],
			removedItems: { name: string }[]
		},
		setDimentions: (names: string[]) => void,
		dimentions: { name: string }[],
		index: string
	): void {
		if (addedItems.length > 0) {
			const itemsToAdd = addedItems.filter(item => dimentions
				.map(dim => dim.name)
				.includes(item.name) == false);

			const itemNamesToAdd = itemsToAdd.map(x => x.name);
			setDimentions([...dimentions.map(x => x.name), ...itemNamesToAdd]);

			if (parseInt(index) > -1) {
				let element = this.drillDownDimensionList.find(x => x.index === parseInt(index));
				if (!isNil(element))
					element.items.push(...itemNamesToAdd);
			}
		}
		else if (removedItems.length > 0) {
			const removedNames = removedItems.map(x => x.name);
			setDimentions([...dimentions.map(x => x.name).filter(x => !removedNames.includes(x))]);

			let element = this.drillDownDimensionList.find(x => x.index === parseInt(index));
			let indexToRemove = -1;
			element.items.forEach((item, index) => {
				if (item == removedNames[0])
					indexToRemove = index;
			});
			element.items.splice(indexToRemove, 1);
		}
	}

	addFilterDimension() {
		let max = 0;
		if (this.drillDownDimensionList.length > 0) {
			max = Math.max(...this.drillDownDimensionList.map(x => x.index));
		}
		this.drillDownDimensionList.push({ index: max + 1, items: [], isNew: true });
	}

	dropDownLisRemoveItem(e) {
		let indexToRemove = e.element.id;
		const index = this.drillDownDimensionList.findIndex(x => x.index === parseInt(indexToRemove));
		this.drillDownDimensionList.splice(index, 1);
	}

	saveDrillDownPopup() {
		let drillDownPopupData: any[] = [];
		this.drillDownDimensionList.forEach(dropDownValue => {

			let name: string[] = [];
			dropDownValue.items.forEach(item => {
				if (isNil(item[0]) || isNil(item[0].title))
					name.push(item);
				else
					name.push(item[0].name);
			});
			drillDownPopupData.push(name);

		});
		return drillDownPopupData;
	}

	setDrillDownDimensions(drillDownConfig) {
		if (!isNil(drillDownConfig)) {
			JSON.parse(drillDownConfig).forEach((value, index) => {
				let selected: any[] = [];
				let name: string[] = [];
				value.forEach(item => {
					name.push(item);
					selected.push({ name: item });
				});

				this.drillDownDimensionList.push({ index: index, items: name, selected: selected, isNew: false });
			});
		}
	}

	async created() {
		try {
			colorService.reset();
			if (isNil(this.model) || isNil(this.model.chartType))
				this.model.chartType = 'line';

			this.loading = true;

			if (this.$route.query.idChart != undefined) {
				var chart = await apiService.get('charts', this.$route.query.idChart.toString());
				this.model.name = chart.name;
				this.model.chartType = chart.type;
				this.groupedByWeek = chart.groupingByWeek;

				if (!isNil(chart.drillDownConfig) && (isArray(JSON.parse(chart.drillDownConfig)) && JSON.parse(chart.drillDownConfig).length > 0)) {
					this.isDrillDownPopupNew = false;
					this.setDrillDownDimensions(chart.drillDownConfig);
				}

				const rawQuery = JSON.parse(chart.query);
				const loadedQueries = isArray(rawQuery) ? rawQuery : [rawQuery];
				this.globalQuery = JSON.parse(!isNil(chart) ? chart.globalQuery ?? null : null);
				const filter = !isNil(this.globalQuery) ? this.globalQuery.globalFilter ?? {} : {};
				const isValidGlobalFilter = !isNil(filter) && filter.length > 0 && (!isNil(filter[0].member) || !isNil(filter[0].and) || !isNil(filter[0].or));
				if (isValidGlobalFilter)
					this.globalFilter = filter;

				loadedQueries.forEach((query, index) => {
					if (isNil(this.queries[index]))
						this.queries.push({ id: +new Date + index, queryJson: {} });

					if (!isNil(query.filters) && isArray(query.filters) && query.filters.length > 0 && isValidGlobalFilter) {
						query.filters = _.differenceWith(query.filters, filter, _.isEqual);
						if (query.filters.length > 0) {
							query.filters[0].and = _.differenceWith(query.filters[0].and, filter, _.isEqual);
						}
					}

					this.preloadedQueries.push(query);
				});

				let configFromDb = JSON.parse(chart.additionalConfig ?? null);
				if (isNil(configFromDb))
					configFromDb = {
						isPercentage: this.model.chartType === 'pie',
						isStacked: false
					};
				if (Array.isArray(configFromDb)) {
					this.chartConfigs = configFromDb;
				} else {
					this.chartConfigs = [{ ...configFromDb }];
				}
				if (this.isOldSingleQuery()) {
					const singleQuery = JSON.parse(chart.query);
					this.globalQuery = {
						query: {
							dimensions: singleQuery.dimensions,
							limit: singleQuery.limit,
							timeDimensions: singleQuery.timeDimensions
						}
					};
				}
			}

			this.customer = customerService.getCustomer();
			if (this.customer != null) {
				const cube = await cubejsService.cubejsApi(this.customer);
				this.cubejsApi = cube;
			}
		} finally {
			this.loading = false;

			this.$watch(() => this.chartConfigs, (data) => {
				if (data.length > 1)
					_.map(data, function (c) {
						c.isMultiple = true;
						return c;
					});
			});
		}
	}

	get chartType() {
		if (isNil(this.model) || isNil(this.model.chartType))
			return 'line';

		return this.model.chartType;
	}

	get areAllQueriesPresent() {
		// return true;

		if (isNil(this.queries) || !isArray(this.queries))
			return false;

		return this.queries.every(x => x.isQueryPresent);
	}

	isOldSingleQuery(): boolean {
		return isNil(this.globalQuery);
	}

	onConfigUpdate(newConfig) {
		if (!isEqual(this.chartConfigs, newConfig))
			this.chartConfigs = newConfig;
	}

	onGlobalFilterUpdated(val) {
		if (isNil(this.drillDownDimensionList) || isNil(this.drillDownDimensionList[0]))
			return;

		const nextItemIndex = this.drillDownDimensionList.findIndex((item) =>
			this.globalDimensions.every((dimension) =>
				item.items.includes(dimension.name)
			)
		) + 1;
		const nextItem = this.drillDownDimensionList[nextItemIndex];
		if (isNil(nextItem))
			return;

		this.saveStatusBeforeDrilldown();

		const operator = 'equals';
		const filterSets = this.chartConfigs[0].axisDimensions.map((dimension) => {
			const filterSet = {
				member: dimension.name,
				operator: operator,
				values: [val[dimension.name]],
			};
			return filterSet;
		});

		if (!this.globalFilter || !this.globalFilter[0] || Object.keys(this.globalFilter[0]).length === 0) {
			this.globalFilter = [{ and: [...filterSets] }];
		} else if (this.globalFilter.length === 1 && !this.globalFilter[0].and) {
			const andArray = [this.globalFilter[0], { and: [...filterSets] }];
			this.globalFilter = [{ and: andArray }];
		} else if (!this.globalFilter[0].and) {
			this.globalFilter[0].and = [...filterSets];
		} else {
			this.globalFilter[0].and.push(...filterSets);
		}

		this.drillDownDimension = nextItem.items;

		const globalFilterRef = (this.$refs.queryBuilderGlobalRef as any).$refs.globalFilterRef;
		globalFilterRef.setInternalFilter(this.globalFilter);
	}

	onAddNewQuery() {
		const newId = +new Date();
		this.queries.push({ id: newId, queryJson: {} });

		let chartConfig = getDefaultChartConfig();
		chartConfig.idQuery = newId;
		this.chartConfigs.push(chartConfig);
	}

	onGlobalTimeDimensionUpdated(val) {
		this.model.timeDimensions = val;
	}

	// DO NOT REMOVE UNTIL THE REWORK OF THE COMPONENT
	onMeasureUpdates(measures: TCubeMeasure[], index: number) {
		if (!isNil(this.chartConfigs[index])) {
			if (Array.isArray(measures)) {
				if (isNil(this.chartConfigs[index].measures))
					this.$set(this.chartConfigs[index], 'measures', [...measures]);
				else if (!isEqual(this.chartConfigs[index].measures, measures))
					this.chartConfigs[index].measures = [...measures];
			}
			else {
				this.$set(this.chartConfigs[index], 'measures', []);
			}
		}
	}

	get chartTypes() {
		let types = Object.values(ChartType)
			.map(value => value as string)
			.sort();

		if (this.queries.length > 1)
			return types.filter(type => type != 'pie');

		return types;
	}

	get canShowDonutCheckbox() {
		return !_.isNil(this.chartConfigs[0]) && !_.isNil(this.chartConfigs[0].isDonut);
	}

	get canShowStackedCheckbox() {
		return !_.isNil(this.chartConfigs[0]) && !_.isNil(this.chartConfigs[0].isStacked);
	}

	get isPie() {
		return this.chartType == 'pie';
	}

	get isBar() {
		return this.chartType == 'bar';
	}

	get isRadar() {
		return this.chartType == 'radar';
	}

	get isColorsDefined() {
		if (this.chartType === 'table')
			return false;

		let result = false;
		this.chartConfigs.forEach(config => {
			if (!_.isNil(config)
				&& !_.isNil(config.colors) && _.isArray(config.colors)
				&& config.colors.length > 0)
				result = true;
		});

		return result;
	}

	get canShowPercentage() {
		return !_.isNil(this.chartConfigs[0])
			&& (
				this.chartType == 'pie'
				|| (this.chartType == 'bar' && !_.isNil(this.chartConfigs[0]) && !_.isNil(this.chartConfigs[0].isStacked) && this.chartConfigs[0].isStacked)
			);
	}

	convertCaptionIfNeeded(legendItem) {
		return tryTranslateCaption(legendItem.localeValue || legendItem.value, this.$t);
	}

	globalDimensions: any = null;
	globalGranularity: any = null;
	globalFilter: any = null;
	globalQuery: any = null;

	setGlobalValues(index, dimensions, granularity) {

		if (index === 0) {
			this.$set(this, 'globalDimensions', dimensions);

			let td = cloneDeep(granularity);
			if (isNil(td) || td.length === 0)
				td = null;
			else
				this.$set(td[0], 'dateRange', undefined);
			this.$set(this, 'globalGranularity', td);
		}
	}

	get availableDimensionsForAxis() {
		const result = this.model.dimensions.map(dim => ({
			...dim,
			caption: this.$t(dim.name)
		}));
		if (Array.isArray(this.model.timeDimensions) && this.model.timeDimensions.length) {
			const timeDimension = this.model.timeDimensions[0].dimension;
			result.push({
				...timeDimension,
				caption: this.$t(timeDimension.name)
			});
		}
		return result;
	}

	get genericFieldsDictionary(): Record<string, boolean> {
		const result: Record<string, boolean> = {};
		this.genericFields.forEach(gf => {
			result[gf] = true;
		});
		return result;
	}
	chartRefreshKey: number = +new Date();
	get queriesToRender(): Query[] {
		this.chartRefreshKey = +new Date();
		if (!isNil(this.queries) && this.queries.length > 0 && !isNil(this.queries[0].queryJson)) {
			if (this.queries.length === 1) {
				return [this.queries[0].queryJson.query];
			} else if (!isNil(this.queries) && this.queries.length > 0 && !this.queries.some(x => isNil(x.queryJson))) {
				return this.queries.map(x => x.queryJson.query);
			} else
				return [];
		} else {
			return [];
		}
	}

	get isModelValid(): boolean {
		return this.model.name !== null && this.isNameValid;
	}

	onRemoveQuery(id) {
		const index = this.queries.findIndex(x => x.id === id);
		this.queries.splice(index, 1);

		this.preloadedQueries = [];

		this.chartConfigs.splice(index, 1);
	}

	toggleAddQueryTooltip() {
		this.addQueryTooltipVisibility = !this.addQueryTooltipVisibility;
	}

	setIsQueryPresent(query, isQueryPresent) {
		this.$set(query, 'isQueryPresent', isQueryPresent);
	}

	onCustomizeClicked() {
		this.isCustomizationpanelOpened = !this.isCustomizationpanelOpened;
	}

	onDrillDownPopupOpen() {
		this.isDrillDownPopupVisible = true;
	}

	findElement(elements, element) {
		return elements.name === element;
	}

	onCancelClick() {
		const idDashboard = this.$route.query.idDashboard;
		this.$router.push({
			name: 'home',
			query: { idDashboard }
		});
	}

	async onSaveClick(): Promise<void> {
		const idDashboard = this.$route.query.idDashboard;
		this.globalQuery = { ...this.globalQuery, ...{ 'globalFilter': this.globalFilter } };

		const drillDownConfig = this.saveDrillDownPopup();

		if (this.$route.query.idChart == undefined) {
			const a = _.cloneDeep(this.chartConfigs);
			// delete (a || {}).version;
			const result = await apiService.post('charts', 'create', {
				name: this.model.name,
				type: this.chartType,
				query: this.queriesToRender,
				idCustomer: customerService.getCustomer(),
				groupingByWeek: this.groupedByWeek,
				additionalConfig: a,
				globalQuery: this.globalQuery,
				DrillDownConfig: drillDownConfig
			});
			await apiService.post('dashboards', `${idDashboard}/addChart`, { idChart: result.id });
		} else {
			const a = _.cloneDeep(this.chartConfigs);
			// delete (a || {}).version;
			await apiService.post('charts', `${this.$route.query.idChart}/update`, {
				name: this.model.name,
				type: this.chartType,
				query: this.queriesToRender,
				groupingByWeek: this.groupedByWeek,
				additionalConfig: a,
				globalQuery: this.globalQuery,
				DrillDownConfig: drillDownConfig
			});
		}

		this.$router.push({
			name: 'home',
			query: { idDashboard }
		});
	}

	changeColor(hex, legendItem, configIndex) {
		this.chartConfigs.forEach((element, index) => {
			element.colors.forEach(color => {
				if (color.value === legendItem.value && configIndex == index)
					color.fillColor = hex;
			});
		});
	}

	loadedQuery(index, query) {
		let resultQuery;
		if (isNil(query.queryJson) || isNil(query.queryJson.query))
			resultQuery = this.preloadedQueries[index];
		else
			resultQuery = query.queryJson.query;

		return resultQuery;
	}

	onQueryMoved(item) {
		let newConfigs = cloneDeep(this.chartConfigs);
		let splicedConfig = newConfigs.splice(item.moved.oldIndex, 1);
		let movedConfig: IChartConfig = splicedConfig[0];

		newConfigs.splice(item.moved.newIndex, 0, movedConfig);
		newConfigs.forEach((config, configIndex) => {
			config.colors.forEach(color => {
				color.queryIndex = configIndex;
			});
		});

		this.chartConfigs = newConfigs;
	}

}


